import { extendTheme } from '@chakra-ui/react';
// Base component style overrides
import { Accordion } from './components/base/accordion';
import { Alert } from './components/base/alert';
import { Badge } from './components/base/badge';
import { Breadcrumb } from './components/base/breadcrumb';
import { Button } from './components/base/button';
import { Card } from './components/base/card';
import { Checkbox } from './components/base/checkbox';
import { CloseButton } from './components/base/close-button';
import { Container } from './components/base/container';
import { Divider } from './components/base/divider';
import { Drawer } from './components/base/drawer';
import { Form } from './components/base/form';
import { FormError } from './components/base/formError';
import { FormLabel } from './components/base/formLabel';
import { Heading } from './components/base/heading';
import { Icon } from './components/base/icon';
import { Input } from './components/base/input';
import { Link } from './components/base/link';
import { List } from './components/base/list';
import { Menu } from './components/base/menu';
import { Modal } from './components/base/modal';
import { NumberInput } from './components/base/number-input';
import { Popover } from './components/base/popover';
import { Progress } from './components/base/progress';
import { Radio } from './components/base/radio';
import { Select } from './components/base/select';
import { Skeleton } from './components/base/skeleton';
import { Spinner } from './components/base/spinner';
import { Switch } from './components/base/switch';
import { Tabs } from './components/base/tabs';
import { Tag } from './components/base/tag';
import { Text } from './components/base/text';
import { Textarea } from './components/base/textarea';
import { Tooltip } from './components/base/tooltip';
// Project Component style overrides
import App from './components/project/_app';
import Header from './components/project/header';
import OfflineBanner from './components/project/offline-banner';
import { breakpoints } from './foundations/breakpoints';
import { colors } from './foundations/colors';
import { gradients } from './foundations/gradients';
import { layerStyles } from './foundations/layerStyles';
import { shadows } from './foundations/shadows';
import { sizes } from './foundations/sizes';
import { space } from './foundations/space';
import { styles } from './foundations/styles';
import { textStyles } from './foundations/textStyles';
import { typography } from './foundations/typography';

// Please refer to the Chakra-Ui theme customization docs found
// here https://chakra-ui.com/docs/theming/customize-theme to learn
// more about extending and overriding themes for your project.
const overrides = {
    styles,
    layerStyles,
    colors,
    breakpoints,
    sizes,
    space,
    gradients,
    shadows,
    textStyles,
    typography,
    components: {
        // base components
        Accordion,
        Alert,
        Badge,
        Button,
        Checkbox,
        CloseButton,
        Container,
        Divider,
        Drawer,
        Form,
        FormError,
        FormLabel,
        Icon,
        Input,
        Link,
        List,
        Menu,
        Modal,
        Popover,
        Radio,
        Select,
        Skeleton,
        Switch,
        Tabs,
        Tooltip,
        Text,
        Textarea,
        Spinner,
        Heading,
        Card,
        Breadcrumb,
        Progress,
        NumberInput,
        Tag,
        // project components
        App,
        Header,
        OfflineBanner,
    },
};

export const theme = extendTheme(overrides);
